import type { EmsComponents } from '@ngsos/portal-core/api/ems';

export type ChecklistDto =
  EmsComponents['schemas']['ChecklistDto'];

export function filterChecklists(
  checklists: readonly ChecklistDto[],
  searchText: string | null,
): ChecklistDto[] {
  if (searchText == null || searchText.trim() === '') {
    return [...checklists];
  }

  const needle = searchText.toUpperCase();
  return checklists.filter(
    (checklist) =>
      (checklist.title ?? '').toUpperCase().includes(needle) ||
      (checklist.description ?? '').toUpperCase().includes(needle),
  );
}

export function compareOrdinalIgnoreCase(a: string, b: string): number {
  const upperA = a.toUpperCase();
  const upperB = b.toUpperCase();
  if (upperA < upperB) {
    return -1;
  }
  if (upperA > upperB) {
    return 1;
  }
  return 0;
}

export function sortChecklistsByTitle(checklists: readonly ChecklistDto[]): ChecklistDto[] {
  return [...checklists].sort((a, b) => compareOrdinalIgnoreCase(a.title ?? '', b.title ?? ''));
}
